import { render, staticRenderFns } from "./video_03.vue?vue&type=template&id=19431e12&scoped=true&"
import script from "./video_03.vue?vue&type=script&lang=js&"
export * from "./video_03.vue?vue&type=script&lang=js&"
import style0 from "./video_03.vue?vue&type=style&index=0&id=19431e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19431e12",
  null
  
)

export default component.exports